import React, { useEffect, useRef, useState } from "react";

import JoditEditor from "jodit-react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ClipLoader from "react-spinners/ClipLoader";
import swal from "sweetalert2";
import "./../../styles/custom.css";

const EditContent = () => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const params = useParams();
  const [newContent, setNewContent] = useState({});
  const editor = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`/content/admin/${params.id}`)
      .then((res) => res.data.data)
      .then((data) => {
        // console.log(data);
        setContent(data.pageContent);
        setTitle(data.pageHeading);
      });
  }, []);

  const newContentData = {
    pageContent: newContent,
  };

  const updateContent = (e) => {
    setLoading(true);
    // console.log("id", newContentData);
    // console.log("new content ==> ", newContentData);
    axios
      .patch(`/content/${params.id}`, newContentData)
      .then((res) => {
        // console.log(res);
        // console.log(newContentData.pageContent.split(":"));
        // setLoading(false);
        swal.fire({
          text: "Updated Successfully!",
          icon: "info",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
        navigate(-1);
      })
      .catch((err) => {
        // setLoading(false);
        // console.log("res ==> ", err.response.data.message);
        let msg = err.response.data.message;
        swal.fire({
          text: `${msg}`,
          icon: "info",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      });
  };

  const handleCloseButton = () => {
    navigate("/content");
  };

  return (
    // <Container>
    <>
      <div
        className="editing-box p-3"
        style={{ backgroundColor: "white", height: "auto" }}
      >
        <div className="box">
          <div
            className="box d-flex"
            style={{ justifyContent: "space-between" }}
          >
            <h3 className="header">Edit Details</h3>
            <Container>
              <i
                className="fa fa-close fonts"
                onClick={handleCloseButton}
                style={{ fontSize: "large" }}
              ></i>
            </Container>
          </div>

          <div
            className="main mx-auto p-3 m-3"
            style={{ border: "2px solid #bebdbf", width: "80%" }}
          >
            <div
              className="title p-2 mb-2"
              style={{
                // border: "2px solid red",
                backgroundColor: "#d5cce0",
                color: "grey",
              }}
            >
              {" "}
              {title}
            </div>

            <CKEditor
              editor={ClassicEditor}
              data={content}
              // onReady={editor => {
              //     console.log('Editor is ready to use!', editor);
              // }}
              config={{
                toolbar: [
                  "undo",
                  "redo",
                  "|",
                  "heading",
                  "|",
                  "bold",
                  "italic",
                  "|",
                  "link",
                  "bulletedList",
                  "numberedList",
                ],
                image: {
                  toolbar: [
                    "imageTextAlternative",
                    "imageStyle:full",
                    "imageStyle:side",
                  ],
                },
                table: {
                  contentToolbar: [
                    "tableColumn",
                    "tableRow",
                    "mergeTableCells",
                  ],
                },
                extraAllowedContent: "table(*)",
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setNewContent(data);
                // console.log("omg", data);
              }}

              // onBlur={(event, editor) => {
              //     console.log('Blur.', editor);
              // }}
              // onFocus={(event, editor) => {
              //     console.log('Focus.', editor); `
              // }}
            />
            <button
              type="submit"
              onClick={updateContent}
              className="Submit my-3 btn-lg"
              style={{
                width: "100%",
                border: "1px solid grey",
                height: "50px",
                borderRadius: "2px",
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
    // </Container>
  );
};

export default EditContent;

const Container = styled.div`
  i {
    /* text-align: end; */
    position: absolute;
    top: 20px;
    right: 30px;
    font-size: 1.6rem;
    cursor: pointer;

    :hover {
      color: red;
      font-size: 1.8rem;
      cursor: pointer;
    }
  }
`;

// About Us At AlgoSports23, we combine a passion for sports with advanced analytics to offer accurate predictions and rankings for leagues like the NBA, WNBA, and college basketball. Our platform empowers sports enthusiasts to engage in competitive forecasting using data-driven insights. Join us to explore sports through the lens of sophisticated algorithms and elevate your prediction skills in our engaging contests.For more information,,, visit AlgoSports23.
